import logo from "@/assets/invoicevault-logo.jpg";
import { site } from "@/config/site";
import { cn } from "@/utils/cn";

type BrandLogoProps = {
  showName?: boolean;
  className?: string;
  iconClassName?: string;
};

export function BrandLogo({
  showName = true,
  className,
  iconClassName = "h-8 w-8",
}: BrandLogoProps) {
  return (
    <div className={cn("flex items-center gap-2.5 font-bold text-[var(--text)]", className)}>
      <img
        src={logo}
        alt=""
        aria-hidden
        className={cn("shrink-0 rounded-lg object-contain", iconClassName)}
      />
      {showName ? <span>{site.name}</span> : null}
    </div>
  );
}
